const STATS = [
    { value: '100M+', label: 'Pieces mailed' },
    { value: '5,000+', label: 'Trusted customers' },
    { value: '2-day', label: 'Production available' },
    { value: '★ 5.0', label: 'Customer rating' },
]

export default function SocialProof() {
    return (
        <section className="bg-[#FFF7EC] border-y border-[color-mix(in_oklab,_#1f2937_10%,_transparent)]">
            <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6 lg:py-7 flex flex-col items-start lg:items-center gap-5">
                <span
                    className="text-xs font-semibold uppercase text-[color-mix(in_oklab,_#3F454F_55%,_transparent)] text-left lg:text-center"
                    style={{ letterSpacing: '0.18em' }}>
                    Trusted by marketing agencies and their clients across the
                    U.S.
                </span>
                <div className="w-full flex flex-row flex-wrap items-center justify-start lg:justify-center gap-x-10 gap-y-4 lg:gap-x-14">
                    {STATS.map((stat, i) => (
                        <div
                            key={i}
                            className="flex flex-row items-baseline gap-2">
                            <span className="text-2xl lg:text-3xl font-bold text-[#3F454F] tracking-tight">
                                {stat.value}
                            </span>
                            <span className="text-sm text-[color-mix(in_oklab,_#3F454F_65%,_transparent)]">
                                {stat.label}
                            </span>
                        </div>
                    ))}
                    <div className="flex flex-row items-center gap-2.5 basis-full lg:basis-auto">
                        <div
                            className="flex flex-col items-center justify-center w-10 h-10 rounded-lg text-white font-black leading-none"
                            style={{
                                background:
                                    'linear-gradient(to bottom right, #ED5C2F, #F28230)',
                                boxShadow: '0 2px 6px rgba(237,92,47,0.28)',
                            }}>
                            <span className="text-xs font-black">INC</span>
                        </div>
                        <span className="text-sm font-bold text-[#3F454F] tracking-tight">
                            Inc. 5000
                        </span>
                    </div>
                </div>
            </div>
        </section>
    )
}
